import { useMutation } from "@tanstack/react-query"
import type { AxiosError } from "axios"
import Cookies from "js-cookie"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { LuLogOut } from "react-icons/lu"
import { toast } from "react-toastify"

import Confirm from "@/components/Confirm/Confirm"
import { AUTH_COOKIE_NAME } from "@/constants/auth"
import useAxios from "@/hooks/useAxios"
import { queryClient } from "@/queries/queries"
import type { ApiResponse } from "@/types"
import { useStore } from "@/zustand/store"

export default function LogoutBtn() {
  const { t, i18n } = useTranslation()
  const [logoutOpen, setLogoutOpen] = useState(false)
  const axios = useAxios()
  const setAuthData = useStore((state) => state.setAuthData)

  const handleLogout = useMutation(handleLogoutRequest, {
    onSuccess: (data) => {
      setAuthData(undefined)
      Cookies.remove(AUTH_COOKIE_NAME)
      toast.success(
        i18n.language === "ar" ? "تم تسجيل الخروج بنجاح" : data.data.message
      )
      queryClient.clear()
    },
    onError: (err: AxiosError<ApiResponse>) => {
      toast.error(err.response?.data.message)
      if (err.response?.status == 401) {
        setAuthData(undefined)
        Cookies.remove(AUTH_COOKIE_NAME)
        queryClient.clear()
      }
    },
  })

  function handleLogoutRequest() {
    return axios.post(`student/logout`)
  }

  return (
    <>
      <button
        className="nav__item  d-flex gap-3 align-items-center px-4 btn"
        onClick={() => setLogoutOpen(true)}
      >
        <span className="list-icon">{<LuLogOut />}</span>
        <p>{t("buttons.logout")}</p>
      </button>
      <Confirm
        isOpen={logoutOpen}
        setIsOpen={setLogoutOpen}
        type="logout"
        message={t("confirm.logout.message")}
        confirmFunc={() => handleLogout.mutate()}
        loading={handleLogout.isLoading}
      />
    </>
  )
}
